export default __webpack_public_path__ + "static/media/profile.e4f79838.svg";